export const VENDOR_VALIDATION_SCHEMA = {
  // General Details
  name: {
    required: 'Vendor name is required',
  },
  // Accounting Details
  pan: {
    required: 'PAN is required',
  },
  gstin: {
    required: 'GSTIN is required',
  },
  currency: {
    required: 'Currency is required',
  },
  purchase_expiry_period: {
    type: 'number',
  },
  // Contact Details
  contact_name: {
    required: 'Contact name is required',
  },
  contact_email: {
    required: 'Contact email is required',
    type: 'email',
  },
  contact_phone: {
    required: 'Phone number is required',
    type: 'phone',
  },
  // Billing Address
  contact_address_line_1: {
    required: 'Address line 1 is required',
  },
  contact_country: {
    required: 'Country is required',
  },
  contact_pincode: {
    required: 'pincode is required',
  },
  contact_state: {
    required: 'state is required',
  },
  contact_city: {
    required: 'city is required',
  },
};
